"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = exports.APP_NAME = void 0;
var _auth = require("@ori/auth");
var _culture = require("@ori/culture");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("./components");
var _containers = require("./containers");
var _contexts = require("./contexts");
var _RegisterPage = _interopRequireDefault(require("./pages/RegisterPage"));
var _jsxRuntime = require("react/jsx-runtime");
const APP_NAME = exports.APP_NAME = 'checkout-registration';
const App = ({
  configuration,
  handleCallbackRegistrationId
}) => {
  const {
    formattedToken
  } = (0, _auth.useToken)();
  if (!formattedToken) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ErrorBoundary, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ConfigurationProvider, {
      value: configuration,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Acquisition,
        project: APP_NAME,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Loading, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.I18nContainer, {
            ...configuration,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ApiProvider, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.VirtualPageAnalyticsProvider, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.NotificationProvider, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.FormErrorProvider, {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.ClientCultureProvider, {
                      tenant: configuration.tenant,
                      language: configuration.currentLanguage,
                      options: {
                        swr: {
                          suspense: true
                        }
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ContentsContainer, {
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RegisterPage.default, {
                          handleCallbackRegistrationId: handleCallbackRegistrationId
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.App = App;
